<!-- Content -->
<div class="content container-fluid">
  <!-- Page Header -->
  <header class="page-header">
    <nav attr.aria-label="{{ 'wcag.breadcrumb' | translate }}">
      <ol class="breadcrumb">
        <breadcrumb></breadcrumb>
      </ol>
    </nav>
    <h1>{{ 'general.branding' | translate }}</h1>
  </header>
  <!-- End Page Header -->

  <!-- Nav -->

  <tab-menu
    [itemType]="'/configuration-options/branding'"
    [tabMenuElements]="arrayTabMenuObjects"
    (activeTab)="setActiveTab($event)"
  ></tab-menu>

  <div class="w-100">
    <router-outlet></router-outlet>
  </div>
</div>
